module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"container outer-container\">\n  <div class=\"page-container\" id=\"page-container\">\n    <div class=\"loading black-overlay\"></div>\n  </div>\n</div>\n<header class=\"header-container\" id=\"header-container\"></header>\n";
  });